"use client";

import original from "react95/dist/themes/original";
import { ThemeProvider } from "styled-components";

export function Wrapper({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={original}>{children}</ThemeProvider>;
}
